/* @flow */
import React, { PureComponent } from 'react';
import ProfilePhoto from './ProfilePhoto';
import UserDetails from './UserDetails';

class GeneralSettings extends PureComponent {
    render() {
        return (
            <div>
                <ProfilePhoto />
                <UserDetails />
            </div>
        );
    }
}

export default GeneralSettings;
